import {
  USFlag,
  SpainFlag,
  SaudiArabiaFlag,
  FranceFlag,
  GermanyFlag,
  ChinaFlag,
} from "../assets/icons";

// export const leaderboardData = [
//   {
//     title: "DarkLordNathan",
//     point: 2000,
//     path: "/png/LB1.png",
//   },
//   {
//     title: "BorgCollective",
//     point: 1000,
//     path: "/png/LB2.png",
//   },
//   {
//     title: "Bulletz4Breakfast",
//     point: 3000,
//     path: "/png/LB3.png",
//   },
//   {
//     title: "TheFinalCountdown",
//     point: 1500,
//     path: "/png/LB4.png",
//   },
//   {
//     title: "IronMAN77	",
//     point: 4500,
//     path: "/png/LB5.png",
//   },
// ];

export const orders = [
  {
    id: 6065,
    date: "1 Feb, 2020",
    time: "01:34 pm",
    status: "Pending",
    items: 3,
    amount: "₦1,000",
  },
  {
    id: 9151,
    date: "24 May, 2020",
    time: "01:08 pm",
    status: "Successful",
    items: 3,
    amount: "₦12,000",
  },
  {
    id: 8013,
    date: "21 Sep, 2020",
    time: "02:10 pm",
    status: "Reversed",
    items: 2,
    amount: "₦1,000",
  },
  {
    id: 9261,
    date: "21 Sep, 2020",
    time: "02:30 pm",
    status: "Rejected",
    items: 2,
    amount: "₦1,120",
  },
];

export const CP_Packages = {
  card: [
    {
      title: "880 CP",
      price: "₦14,850",
      discount: "15% Off",
      image: "/png/CP.png",
    },
    {
      title: "880 CP",
      price: "₦14,850",
      discount: "15% Off",
      image: "/png/CP.png",
    },
    {
      title: "880 CP",
      price: "₦14,850",
      oldPrice: "₦14,850",
      discount: "15% Off",
      image: "/png/CP.png",
    },
    {
      title: "880 CP",
      price: "₦14,850",
      discount: "15% Off",
      image: "/png/CP.png",
    },
    {
      title: "880 CP",
      price: "₦14,850",
      oldPrice: "₦14,850",
      discount: "15% Off",
      image: "/png/CP.png",
    },
    {
      title: "880 CP",
      price: "₦14,850",
      oldPrice: "₦14,850",
      discount: "15% Off",
      image: "/png/CP.png",
    },
  ],
};

export const cartItems = [
  {
    id: 1,
    name: "800 CP",
    product: "Call of Duty: Mobile",
    image: "/png/CP.png",
    price: "₦12,707.5",
    coins: 232,
    quantity: 1,
  },
  {
    id: 2,
    name: "₦100",
    product: "MTN Airtime",
    image: "/images/mtn.png",
    price: "₦12,707.5",
    coins: 232,
    quantity: 1,
  },
  {
    id: 3,
    name: "₦1,000",
    product: "Prepaid",
    image: "/images/AEDC.png",
    price: "₦12,707.5",
    coins: 232,
    quantity: 1,
  },
];

export const Categories = [
  {
    id: 1,
    title: "directGameTopUp",
    description: "directGameTopUp",
    image: "/images/Coins.png",
  },
  {
    id: 2,
    title: "gameCards",
    description: "gameCards",
    image: "/images/game.png",
  },
  {
    id: 3,
    title: "dataServices",
    description: "dataServices",
    image: "/images/Phone.png",
  },
  {
    id: 4,
    title: "giftCards",
    description: "prepaidServices",
    image: "/images/Icon.png",
  },
  {
    id: 5,
    title: "airtimeServices",
    description: "airtimeServices",
    image: "/images/Phone.png",
  },
  {
    id: 6,
    title: "electricityPayment",
    description: "electricityPayment",
    image: "/images/Thunder.png",
  },
  {
    id: 7,
    title: "cableTV",
    description: "cableTV",
    image: "/images/Tv 1.png",
  },
];

export const LANGUAGES = [
  {
    code: "en",
    name: "English",
    country: "United States",
    dir: "ltr",
    Flag: USFlag,
  },
  {
    code: "es",
    name: "Español",
    country: "Spain",
    dir: "ltr",
    Flag: SpainFlag,
  },
  {
    code: "fr",
    name: "Français",
    country: "France",
    dir: "ltr",
    Flag: FranceFlag,
  },
  {
    code: "de",
    name: "Deutsch",
    country: "Germany",
    dir: "ltr",
    Flag: GermanyFlag,
  },
  {
    code: "ar",
    name: "العربية",
    country: "Saudi Arabia",
    dir: "rtl",
    Flag: SaudiArabiaFlag,
  },
  {
    code: "zh",
    name: "中文",
    country: "China",
    dir: "ltr",
    Flag: ChinaFlag,
  },
];
